const getters = {
	overlays(state) {
		return state.overlays;
	},
	getOverlay(state) {
		return name => state.overlays[name];
	},
};

export default getters;



// WEBPACK FOOTER //
// ./scripts/sky-lightbox/store/getters.js